import script from "./BlogGoToSite.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogGoToSite.vue?vue&type=script&lang=ts&setup=true"

import "./BlogGoToSite.vue?vue&type=style&index=0&id=92762692&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92762692"]])

export default __exports__